var __WEBPACK_NAMESPACE_OBJECT__ = $;